<script setup lang="ts"></script>

<template>
    <div class="close group" @click="$emit('close')">
        <vue-svg type="icons/x" class="group-hover:rotate-180 transition-transform transform"></vue-svg>
    </div>
</template>

<style lang="scss" scoped>
.close {
    position: absolute;
    width: 64px;
    height: 64px;
    right: 0;
    top: 0;
    background-color: theme("colors.primary");
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;

    @apply text-white hover:text-primary transition-colors;
}
</style>
